import { IManager } from "../../interfaces/IManager";
import { IFixPersonToManager } from "../../interfaces/store/slices/listAgentSlice";
import { TypeDATA_ALL_PAGE } from "../slice/authSliceLogin/authSliceLogin";
import { api } from "./apiCore";

export const permissionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPermission: builder.query<TypeDATA_ALL_PAGE, undefined>({
      query: () => ({
        url: `/auth/permission`,
      }),
      transformResponse: (res: TypeDATA_ALL_PAGE) => {
        if (res.data.manager) {
          const transformManagerItems: IManager[] = [];
          for (let i = 0; i < res.data.manager.length; i++) {
            const currentManager = res.data.manager[i];
            const managerClients: IFixPersonToManager[] = [];
            const managerAgents: IFixPersonToManager[] = [];
            for (let j = 0; j < currentManager.agents.length; j++) {
              const currentPerson = currentManager.agents[j];

              if (currentPerson.type === "client") {
                managerClients.push(currentPerson);
              }

              if (currentPerson.type === "agent") {
                managerAgents.push(currentPerson);
              }
            }
            currentManager.agents = managerAgents;
            currentManager.clients = managerClients;

            transformManagerItems.push(currentManager);
          }
          res.data.manager = transformManagerItems;
        }

        return res;
      },
    }),
  }),
});

export const { useGetPermissionQuery } = permissionApi;
